import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultDlpConfig, getDlpTemplateConfig } from './cfg.dlp.default'; //   getTargetProperty,

const cfg = {
  policyType: 22,
  policySubType: 1,
  tmDpfilters: {
    changeRecipientEmailAddressList: '',
  },
  holderType: 2,
};

export function getDlpGmailOutboundTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined
) {
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.GM.tmDpfilters.notification.ntfAdminMessage',
    'policy.policyTemplate.GM.tmDpfilters.notification.ntfAdminSubject',
    'policy.policyTemplate.GM.tmDpfilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GM.tmDpfilters.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.GM.tmDpfilters.notificatioAdd Labeln.ntfInternalRecipientMessage',
  ];
  const tempConfig = getDefaultDlpConfig();
  merge(tempConfig, cfg);
  return getDlpTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    [],
    ntfI18nReplaceKeys
  );
}
